import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { BillingGuard } from "./core/guards/billing.guard";
import { PaymentsGuard } from "./core/guards/payments.guard";
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { AppComponent } from "./app.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  },
  {
    path: "login",
    redirectTo: "home",
    pathMatch: "full",
  },
  {
    path: "register",
    redirectTo: "home",
    pathMatch: "full",
  },    
  {
    path: 'refresh-profile',
    component: AppComponent,
    data: { title: 'Refresh Profile' }
  },
  {
    path: "agents",
    loadChildren: () =>
      import("./agents/agents.module").then((m) => m.AgentsPageModule),
    canActivate: [MsalGuard],
    data: {
      title: "Contact My Agent"
    },
  },
  {
    path: "billing/:accountNumber",
    loadChildren: () =>
      import("./billing/billing.module").then((m) => m.BillingPageModule),
    canActivate: [MsalGuard],
    data: {
      title: "Billing"
    },
  },
  {
    path: "billing",
    loadChildren: () =>
      import("./billing/billing.module").then((m) => m.BillingPageModule),
    canActivate: [MsalGuard, BillingGuard],
    data: {
      title: "Billing"
    },
  },
  {
    path: "payments/:accountNumber",
    loadChildren: () =>
      import("./payments/payments.module").then((m) => m.PaymentsPageModule),
    canActivate: [MsalGuard],
    data: {
      title: "Payments"
    },
  },
  {
    path: "payments",
    loadChildren: () =>
      import("./payments/payments.module").then((m) => m.PaymentsPageModule),
    canActivate: [MsalGuard, PaymentsGuard],
    data: {
      title: "Payments"
    },
  },
  {
    path: "cards",
    loadChildren: () =>
      import("./cards/cards.module").then((m) => m.CardsPageModule),
    canActivate: [MsalGuard],
    data: {
      title: "ID Cards"
    },
  },
  {
    path: "claims",
    loadChildren: () =>
      import("./claims/claims.module").then((m) => m.ClaimsPageModule),
    canActivate: [MsalGuard],
    data: {
      title: "Claims"
    },
  },
  {
    path: "claims/contact-adjuster",
    loadChildren: () =>
      import("./contact-adjuster/contact-adjuster.module").then(
        (m) => m.ContactAdjusterPageModule
      ),
    canActivate: [MsalGuard],
    data: {
      title: "Contact Adjuster"
    },
  },
  {
    path: "documents",
    loadChildren: () =>
      import("./documents/documents.module").then((m) => m.DocumentsPageModule),
    canActivate: [MsalGuard],
    data: {
      title: "Documents"
    },
  },
  {
    path: "home",
    loadChildren: () =>
      import("./home/home.module").then((m) => m.HomePageModule),
    canActivate: [MsalGuard],
    data: {
      title: "Home"
    },
  },
  {
    path: "new-claim",
    loadChildren: () =>
      import("./new-claim/new-claim.module").then((m) => m.NewClaimPageModule),
    canActivate: [MsalGuard],
    data: {
      title: "New Claim"
    },
  },
  {
    path: "not-found",
    loadChildren: () =>
      import("./not-found/not-found.module").then((m) => m.NotFoundPageModule),
      data: {
        title: "Not Found"
      },
  },
  {
    path: "paperless",
    redirectTo: "paperless/billing",
    pathMatch: "full",
  },
  {
    path: "paperless/billing",
    loadChildren: () =>
      import("./paperless-billing/paperless-billing.module").then(
        (m) => m.PaperlessBillingPageModule
      ),
    canActivate: [MsalGuard],
    data: {
      title: "Paperless Billing"
    },
  },
  {
    path: "paperless/policy",
    loadChildren: () =>
      import("./paperless-policy/paperless-policy.module").then(
        (m) => m.PaperlessPolicyPageModule
      ),
    canActivate: [MsalGuard],
    data: {
      title: "Paperless Policy"
    },
  },
  {
    path: "policies",
    loadChildren: () =>
      import("./policies/policies.module").then((m) => m.PoliciesPageModule),
    canActivate: [MsalGuard],
    data: {
      title: "Policies"
    },
  },
  {
    path: "profile",
    loadChildren: () =>
      import("./profile/profile.module").then((m) => m.ProfilePageModule),
    canActivate: [MsalGuard],
    data: {
      title: "Profile"
    },
  },
  {
      // Dedicated route for redirects
      path: 'auth', 
      component: MsalRedirectComponent
  },  
  {
    path: "**",
    redirectTo: "/not-found",
    data: {
      title: "Not Found"
    },
  },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
      initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Set to enabledBlocking to use Angular Universal
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
